import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../../../shared/base-api-template-service.model';
import {Core2Config} from '../../../../shared/core2Config';
import { ContactMergerSearchContainerModel } from '../../../../../../../../models/aggregates/custom/senwave/crm/contact-merger/contact-merger-search-container.model';

@Injectable({
  providedIn: 'root'
})
export class ContactMergerSearchService extends BaseApiTemplateService<ContactMergerSearchContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_CUSTOM_URL_PREFIX + Core2Config.SENWAVE_PREFIX + Core2Config.CRM_PREFIX + 'contact-merger/search';
    this.endpoint_path = Core2Config.TENANT_CUSTOM_URL_PREFIX + Core2Config.SENWAVE_PREFIX + Core2Config.CRM_PREFIX + 'contact-merger/search';
    this.httpClient = http;
  }
}
